import {
  get,
  post,
  del,
  put,
  postForm
} from './request'

const HOST = BASEURL

//注册
export const register = data => post(HOST + '/api/Login/register', data)

//注册 -- 获取邮箱验证码
export const sendMailCode = data => post(HOST + '/api/Login/sendMailCode', data)

//注册 -- 获取手机验证码
export const sendPhoneCode = data => post(HOST + '/api/Login/sendPhoneCode', data)

//登录
export const Login = data => post(HOST + '/api/Login/login', data)

//重置密码
export const resetPassword = data => post(HOST + '/api/Login/resetPassword', data)

//刷新token
export const refreshToken = data => post(HOST + '/api/Login/refreshToken', data)

//产品列表
export const productList = data => post(HOST + '/api/Product/productList', data)

//产品详情
export const productDetail = data => post(HOST + '/api/Product/productDetail', data)

//产品列表-操作日志
export const productLicenseLogs = data => post(HOST + '/api/Product/licenseLogs', data)



//生成授权码
export const genLicenseCode = data => post(HOST + '/api/Product/genLicenseCode', data)

//回收授权码
export const recoveryLicenseCode = data => post(HOST + '/api/Product/recoveryLicenseCode', data)

// 获取个人资料
export const userDetail = data => post(HOST + '/api/Personal/userDetail', data)

// 修改个人资料
export const userEdit = data => post(HOST + '/api/Personal/userEdit', data)

// 修改备注
export const licenseNote = data => post(HOST + '/api/Product/licenseNote', data)

// 修改授权日期
export const productEdit = data => post(HOST + '/api/Product/productEdit', data)

// 改绑账号前验证
export const changeAccoutVerfiy = data => post(HOST + '/api/Login/changeAccountVerify', data)

// 改绑账号
export const changeAccout = data => post(HOST + '/api/Login/changeAccount', data)


// 后台--------------------------------------------------------
// 后台登录
export const adminLogin = data => post(HOST + '/admin/Login/login', data)

// 后台管理员详情
export const adminPersonalDetail = data => post(HOST + '/admin/Personal/adminDetail', data)

// 后台管理员修改个人资料
export const adminPersonalEdit = data => post(HOST + '/admin/Personal/adminEdit', data)

// 后台用户列表
export const adminUserList = data => post(HOST + '/admin/User/userList', data)

// 后台用户列表
export const adminAddProduct = data => post(HOST + '/admin/User/addProduct', data)

// 后台添加产品列表
export const adminProductList = data => post(HOST + '/admin/Product/productList', data)

// 后台生成激活码
export const adminGenLicenseCode = data => post(HOST + '/admin/User/genLicenseCode', data)

//  后台用户的产品信息列表
export const adminUserProductList = data => post(HOST + '/admin/User/productList', data)

//  后台用户的产品信息详情
export const adminUserProductDetail = data => post(HOST + '/admin/User/productDetail', data)

// 后台单个授权配置编辑
export const adminLicenseConfigEdit = data => post(HOST + '/admin/User/licenseConfigEdit', data)

// 后台恢复授权的订单配置
export const adminLicenseConfigRestore = data => post(HOST + '/admin/User/licenseConfigRestore', data)

//  后台用户详情
export const adminUserDetail = data => post(HOST + '/admin/User/userDetail', data)

//后台产品列表-操作日志
export const adminLicenseLogs = data => post(HOST + '/admin/User/licenseLogs', data)

//后台产品列表-回收授权码
export const adminRecoveryLicenseCode = data => post(HOST + '/admin/User/recoveryLicenseCode', data)


//后台企业公司列表
export const adminCompanyList = data => post(HOST + '/admin/Company/companyList', data)

//后台订单列表
export const adminOrderList = data => post(HOST + '/admin/Order/orderList', data)

//后台订单编辑
export const adminOrderEdit = data => post(HOST + '/admin/Order/orderEdit', data)

//后台订单详情
export const adminOrderDetail = data => post(HOST + '/admin/Order/orderDetail', data)

// 后台订单中的单独配置授权
export const adminOrderCustomLicenses = data => post(HOST + '/admin/Order/customLicenses', data)

//后台订单删除
export const adminOrderDel = data => post(HOST + '/admin/Order/orderDel', data)

//后台产品编辑
export const adminProductEdit = data => post(HOST + '/admin/Product/productEdit', data)
